(function () {
  const wrapper = document.querySelector('.header-wrapper--transparent');
  if (!wrapper) return;

  const SCROLL_THRESHOLD = 20;

  function updateScrollState() {
    const isMobile = window.matchMedia('(max-width: 999px)').matches;

    if (isMobile) {
      wrapper.classList.add('header-wrapper--solid');
      return;
    }

    if (window.scrollY > SCROLL_THRESHOLD) {
      wrapper.classList.add('header-wrapper--solid');
    } else if (!wrapper.matches(':hover') && !wrapper.matches(':focus-within')) {
      wrapper.classList.remove('header-wrapper--solid');
    }
  }

  updateScrollState();

  window.addEventListener('scroll', updateScrollState, { passive: true });
  window.addEventListener('resize', updateScrollState, { passive: true });
  wrapper.addEventListener('mouseleave', updateScrollState);
})();
